var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "opportunity" },
    [
      _c("div", { staticClass: "opportunity__header" }, [
        _vm.resource.country
          ? _c("img", {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: _vm.resource.country.name,
                  expression: "resource.country.name",
                },
              ],
              staticClass: "flag opportunity__flag",
              attrs: { src: _vm.resource.country.flag },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("h2", { staticClass: "opportunity__title" }, [
          _vm._v(_vm._s(_vm.resource.projectName)),
        ]),
        _vm._v(" "),
        _vm.resource.urgent
          ? _c("span", { staticClass: "pill pill--urgent opportunity__pill" }, [
              _vm._v("Urgent"),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("DataList", {
        staticClass: "opportunity__datalist",
        attrs: {
          columns: 2,
          items: [
            {
              title: "Posted",
              value: _vm.resource.createdAt,
              icon: "calendar",
              isSector: false,
            },
            {
              title: "Opportunity Type",
              value: _vm.resource.mandated ? "Mandated" : "Non-Mandated",
              icon: "lock",
              isSector: false,
            },
            {
              title: "Deal Type",
              value: _vm.resource.dealType,
              icon: "deal",
              isSector: false,
            },
            {
              title: "Projected transaction value",
              value: `${_vm.resource.projectedValueFrom}m-${_vm.resource.projectedValueTo}m`,
              icon: "value",
              isSector: false,
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "datalist opportunity__sectors" }, [
        _c("div", { staticClass: "datalist__item dataitem" }, [
          _c("dt", {
            staticClass: "dataitem__title",
            domProps: { textContent: _vm._s("Sector") },
          }),
          _vm._v(" "),
          _c(
            "dd",
            { staticClass: "dataitem__value" },
            _vm._l(_vm.resource.sectors, function (sector) {
              return _c("span", {
                staticClass: "sector",
                domProps: { textContent: _vm._s(sector.name) },
              })
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.resource && _vm.resource.id
        ? _c(
            "router-link",
            {
              staticClass: "btn btn--outline",
              attrs: {
                to: {
                  name: "view-opportunity",
                  params: {
                    opportunity_id: _vm.resource.id,
                  },
                },
              },
            },
            [_vm._v("\n        View Opportunity\n    ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }